import * as sessionApi from "app/api/sessionApi";
import { SessionHelper } from "app/helpers/sessionHelper";
import store from "app/store/store";
export class LogoutHelper {
  static logout: () => void = () => {
    sessionApi.logout();
    store.dispatch.notificationListModel.setPlatform("HOMEPAGE");
    store.dispatch.notificationListModel.loadNotificationList();
    store.dispatch.promoCategoryModel.resetPromotedCategory();
    SessionHelper.clearSessionStorage();
    // check dark mode status from local storage
    let darkModeStatus = SessionHelper.getDarkModeStatus();
    SessionHelper.clearLocalStorage();
    if (darkModeStatus === "true") {
      // clear all local storage but retain dark mode status
      SessionHelper.saveDarkModeStatus(true);
    }
  };
}
